import { createReduxActionTypes } from '../../../utils/actionFactory';
import Optional from '../../../utils/optional';

const OPEN_MOVE_RANGE = 'OPEN_MOVE_RANGE';
const RESET_MOVE_RANGE = 'RESET_MOVE_RANGE';

export const actionTypes = createReduxActionTypes('MOVE_RANGE', [
  OPEN_MOVE_RANGE,
  RESET_MOVE_RANGE
]);

const DEFAULT_STATE = {
  open: false,
  ranges: [],
  fromBE: true,
  resetValues: {}
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[OPEN_MOVE_RANGE]: {
      const { ranges, fromBE, resetValues } = action;
      return {
        ...state,
        open: true,
        ranges,
        fromBE: Optional(fromBE).or(true),
        resetValues: Optional(resetValues).or({})
      };
    }
    case actionTypes[RESET_MOVE_RANGE]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  openMoveRange: ({ ranges, fromBE, resetValues }) => ({
    type: actionTypes[OPEN_MOVE_RANGE],
    ranges,
    fromBE,
    resetValues
  }),
  closeMoveRange: () => ({ type: actionTypes[RESET_MOVE_RANGE] })
};
